import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN ImageCard variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const imageCardVariants = cva('', {
  variants: {
    variant: {
      default: 'flex flex-col gap-md',
      'full-width':
        'relative flex flex-col overflow-hidden rounded-xl min-h-image-card-full-width',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ImageCardVariantProps = VariantProps<typeof imageCardVariants>;
